'use strict';

exports.__esModule = true;
exports.templater = exports.isDefinedNested = exports.getLocalizedElement = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLocalizedElement = exports.getLocalizedElement = function getLocalizedElement(key, translations, data) {
  var localizedString = translations[key] || 'Missing locaized: ' + key;
  return _react2.default.createElement('span', {
    dangerouslySetInnerHTML: { __html: templater(localizedString, data) }
  });
};

/**
 * @func isDefinedNested
 * @desc Check if a nested property exists on an object.
 * @param {Object} target The object that you want to test against
 * @param {string} props The nested props you want verify are defined on target
 * @example 
 *  // checks if theObject.prop1.prop2.prop3 is defined
 *  isDefinedNested(theObject, 'prop1', 'prop2', 'prop3') 
 */
var isDefinedNested = exports.isDefinedNested = function isDefinedNested(target) {
  for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  var firstProp = props.shift();

  if (target[firstProp] === undefined) {
    return false;
  }

  return props.reduce(function (prev, cur, index) {
    if (index === props.length - 1) {
      return prev[cur] !== undefined;
    } else {
      return prev === undefined ? {} : prev[cur];
    }
  }, target[firstProp]);
};

/**
 * @func templater
 * @desc A poor mans template parser 
 * @param {string} strings The template string
 * @param {object} data The data that should be inserted in template
 * @return {string} The template string with the data merged in
 */
var templater = exports.templater = function templater(strings) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var prop in data) {
    var pattern = '\\${\\s*' + prop + '\\s*}';
    var regex = new RegExp(pattern, 'gmi');
    strings = strings.replace(regex, data[prop]);
  }
  return strings;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/lib/utils.js
// module id = 87
// module chunks = 0